import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import EnhancedTable from '../../components/table';
import { SUBSCRIPTOR_LIST_TITLE } from '../../libraries/texts';
import SubscriptorService from '../../services/request-service';
import { cleanSearch } from '../../libraries/utils';
import { subscriptorList as styles } from './styles';

const SubscriptorFormList = props => {
  const { classes } = props;

  let {
    location: { search }
  } = props;
  search = cleanSearch(search);
  return (
    <Card className={classes.card}>
      <CardHeader title={SUBSCRIPTOR_LIST_TITLE} />
      <CardContent className={classes.cardContent}>
        <EnhancedTable service={SubscriptorService} search={search} {...props} />
      </CardContent>
    </Card>
  );
};

SubscriptorFormList.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SubscriptorFormList);
